import axios from 'axios';
import { BASE_URL, PLATFORM_API_PATH } from 'constants/api';
import { PlatformInterface } from 'type/platformType';
import { ApiService } from './apiService';

export class PlatformApiService extends ApiService<PlatformInterface> {
  public async fetchPlatformList(pageSize: number = 100): Promise<PlatformInterface[]> {
    const queryParams = {
      page_size: pageSize.toString(),
    };
    const result = await axios.get(`${BASE_URL}${PLATFORM_API_PATH}`, {
      params: queryParams,
    });
    return result.data.results;
  }
}

export const platformApiService = new PlatformApiService(PLATFORM_API_PATH);
